import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import { Box, Container } from "theme-ui"
import { motion } from "framer-motion"
import underline from "../assets/images/segno.svg"

const HomeHero = ({ page, theme = "dark" }) => {
  const { heroImage, herotext } = page
  return (
    <Box
      sx={{
        position: "relative",
        backgroundColor: "#006fb2",
        mb: 4,
        listStyle: "none",
        height: ["80vh", "70vh", "850px"],
        minHeight: ["80vh", "70vh", "100vh"],
        width: "100%",
        margin: "0",
        display: "flex",
        alignItems: ["flex-start", "center"],
      }}
    >
      {heroImage && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
            ".gatsby-image-wrapper": { width: "100%", height: "100%" },
            overflow: "hidden",
          }}
        >
          {heroImage.gatsbyImageData ? (
            <GatsbyImage image={heroImage.gatsbyImageData} />
          ) : (
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "100%",
                "&:after": {
                  content: "''",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "#006fb2",
                  opacity: "0.1",
                  zIndex: 1,
                },
                video: {
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: ["84% 130px;", "center", "center"],
                },
              }}
            >
              <video
                title={"background-video"}
                id=""
                class=""
                autoplay="autoplay"
                muted="muted"
                loop="loop"
                playsinline="playsinline"
              >
                <source src={heroImage.url} type="video/mp4" />
              </video>
            </Box>
          )}
        </Box>
      )}
      <Container
        sx={{
          position: "relative",
          zIndex: 2,
        }}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.9, y: 200 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ type: "spring", duration: 0.8, delay: 0.3 }}
        >
          <Box
            dangerouslySetInnerHTML={{ __html: herotext }}
            sx={{
              h1: {
                maxWidth: ["580px"],
                color: "light",
                fontSize: [6, 8],
                fontWeight: "300",
                lineHeight: "1.1",
                fontFamily: "body",
                em: {
                  backgroundImage: `url(${underline})`,
                  backgroundPosition: "bottom",
                  backgroundSize: "100%",
                  backgroundRepeat: "no-repeat",
                  pb: "15px",
                  mt: "-15px",
                },
              },
            }}
          />
        </motion.div>
      </Container>
    </Box>
  )
}

export default HomeHero
